module.exports = __webpack_public_path__ + "img/icon-immers@2x.e7ff862f.png";